'use client';

import { useEffect } from 'react';

export function AccessibilityController() {
    useEffect(() => {
        const fontSizeSetting = localStorage.getItem('font-size');
        const highContrastModeSetting = localStorage.getItem('high-contrast-mode');

        if (fontSizeSetting != null) {
            document.body.dataset.accessibilityFontSize = fontSizeSetting;
        }

        if (highContrastModeSetting != null) {
            document.body.dataset.accessibilityHighContrastMode = highContrastModeSetting;
        }
    }, []);

    return null;
}
